export default __webpack_public_path__ + "static/media/icon-check-circle-green.29d66bfb.svg";